export { default } from './AmbiguousCityLink'
